export enum OrganizationRole {
  ADMIN = 'Admin',
  MEMBER = 'Member',
}

export enum JobStatus {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  ONLINE = 'online',
  ONLINE_TERMINATED = 'online_terminated',
  OFFLINE = 'offline',
  REACTIVATING = 'reactivating',
}

export enum WorkExperience {
  NONE = 'NONE',
  LESS_THAN_ONE_YEAR = 'LESS_THAN_ONE_YEAR',
  ONE_TO_TWO_YEARS = 'ONE_TO_TWO_YEARS',
  THREE_TO_FIVE_YEARS = 'THREE_TO_FIVE_YEARS',
  SIX_TO_TEN_YEARS = 'SIX_TO_TEN_YEARS',
  MORE_THAN_TEN_YEARS = 'MORE_THAN_TEN_YEARS',
}

export enum JobTitleType {
  JUNIOR = 'Nachwuchskraft',
  ASSISTANT = 'Hilfskraft',
  SPECIALIST = 'Fachkraft',
  MANAGER = 'Führungskraft',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}

export enum Language {
  DE = 'de',
  EN_US = 'en-US',
}

export enum AddressingOptions {
  ENGLISH = 'english',
  GERMAN_SIE = 'german_sie',
  GERMAN_DU = 'german_du',
}

export enum SalaryType {
  PER_YEAR = 'perYear',
  PER_MONTH = 'perMonth',
  PER_HOUR = 'perHour',
}

export enum SkillRequired {
  REQUIRED = 'required',
  NICE_TO_HAVE = 'niceToHave',
  OPTIONAL = 'optional',
}

export enum JobImportStatus {
  DRAFT = 'draft',
  ABORTED = 'aborted',
  PROCESSING = 'processing',
  JOB_CREATED = 'done',
  FAILED = 'failed',
}
